
import * as Cesium from "cesium";

export const filterRoadSlopeOnDataSource = (dataSource, slopeDeg, condition, reset = false) => {
  if (!dataSource || !dataSource.entities) return;

  const entities = dataSource.entities.values || [];
  if (!entities.length) return;

  if (reset) {
    entities.forEach((entity) => {
      const polyline = entity.polyline;
      if (!polyline) return;

      if (polyline._slopeOriginalMaterial) {
        polyline.material = polyline._slopeOriginalMaterial;
        delete polyline._slopeOriginalMaterial;
      }
    });
    return;
  }

  const now = Cesium.JulianDate.now();

  entities.forEach((entity) => {
    const polyline = entity.polyline;
    if (!polyline || !polyline.positions) return;

    const positions = polyline.positions.getValue(now);
    if (!positions || positions.length < 2) return;

    const first = positions[0];
    const last = positions[positions.length - 1];

    const carto1 = Cesium.Cartographic.fromCartesian(first);
    const carto2 = Cesium.Cartographic.fromCartesian(last);

    const geodesic = new Cesium.EllipsoidGeodesic(carto1, carto2);
    const horizontalDistance = geodesic.surfaceDistance;
    if (!horizontalDistance) return;

    const deltaH = carto2.height - carto1.height;
    const slopeRad = Math.atan2(deltaH, horizontalDistance);
    const entitySlopeDeg = Cesium.Math.toDegrees(Math.abs(slopeRad));

    let match = false;
    if (condition === ">=") match = entitySlopeDeg >= slopeDeg;
    else if (condition === "<=") match = entitySlopeDeg <= slopeDeg;
    else if (condition === ">") match = entitySlopeDeg > slopeDeg;
    else if (condition === "<") match = entitySlopeDeg < slopeDeg;

    if (!polyline._slopeOriginalMaterial) {
      polyline._slopeOriginalMaterial = polyline.material;
    }

    if (match) {
      polyline.material = Cesium.Color.ORANGERED;
    } else {
      polyline.material = polyline._slopeOriginalMaterial;
    }
  });
};
